import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HowDoIVideoLinks } from "src/app/common/commonvariables";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { Claims } from "src/app/_models/common/claims";
import { ClaimsService } from "src/app/_services/common/claims.service";
import {
  AlertPanelTypeEnum,
  ApiRequest,
  FunctionPackageEnum,
  WizardActionEnum,
} from "src/app/_models";
import {
  Wizard,
  WizardDetailRequest,
  WizardResponse,
} from "src/app/_models/common/wizard";
import { environment } from "src/environments/environment";
import { MarketingPopup } from "src/app/_models/common/marketing-popup";
import { WizardComponent } from "src/app/shared/panels/wizard/wizard.component";
import { AlertPanelModel } from "src/app/_models/common/alertPanelModel";
import { parse } from "url";
import { Location } from "@angular/common";
import { WizardService } from "src/app/_services/common/wizard.service";
import { AssignCategoriesToGradeListPanelInputModel } from "src/app/_models/grade/grade";

@Component({
    selector: "setup-grade-wizard",
    templateUrl: "./setup-grade-wizard.component.html",
    standalone: false
})
export class SetupGradeWizardComponent implements OnInit {
  @ViewChild(WizardComponent) wizardComponent: WizardComponent;
  howDoIVideoLink = HowDoIVideoLinks;
  wizardDetails: Wizard[];
  public param: string;
  claimsSubscription: Subscription;
  claims: Claims;
  showgradePanel = false;
  showSetupMileageRate = false;
  redirectStep: number = 0;
  gradePanelData: any;
  showAssignCategoriesToGradeListPanel: boolean = false;
  assignCategoriesToGradeListPanelInputModel: AssignCategoriesToGradeListPanelInputModel;
  isAssigncategoriestogradeSubscribed: boolean;
  showAssignClaimantToGradePopup: boolean;
  assigncategoriestogradePopupModel: MarketingPopup;
  purchaseFunctionList: any[] = [];
  marketingPopupPanel: MarketingPopup;
  isMarketingPopup: boolean;
  alertPanelType: number;
  alertPanelModel = new AlertPanelModel(
    false,
    "",
    [""],
    "",
    "",
    true,
    this.translate.instant("please_review_or_confirm")
  );
  showGradeImportExportPanel:boolean;
  constructor(
    private router: Router,
    private wizardService: WizardService,
    private claimsService: ClaimsService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private location: Location
  ) {
    this.claimsSubscription = this.claimsService.currentClaims.subscribe(
      (claims) => {
        this.claims = claims;
      }
    );
    this.redirectStep = this.route.snapshot.queryParams["step"] || 0;
    this.resetUrl();
  }
  ngOnInit(): void {
    this.GetWizardDetails();
  }
  backToSettings() {
    if (
      localStorage.getItem("isRedirectFromMySubscriptionSettingPage") == "1"
    ) {
      this.router.navigate(["mysubscription"]);
    } else {
      this.router.navigate(["settings"]);
    }
  }
  GetWizardDetails() {
    let request = new ApiRequest<WizardDetailRequest>(
      "GetOrgMileageWizardDetails",
      environment.applicationVersion,
      environment.requestId
    );
    let requestInfo = new WizardDetailRequest();
    requestInfo.WizardAction = WizardActionEnum.Grade;
    request.requestInfo = requestInfo;
    this.wizardService
      .GetWizardDetails(request)
      .subscribe((res: WizardResponse) => {
        this.wizardDetails = res.wizardList;
        this.wizardComponent.setWidthAndHeight();
        if (this.redirectStep) {
          let stepData = new Wizard();
          stepData.stepNum = Number(this.redirectStep);
          setTimeout(() => {
            this.navigateToStep(stepData);
            this.redirectStep = 0;
          }, 100);
        }
      });
  }
  navigateToStep(stepData: Wizard) {
    if (!this.fnAlertPanelRequired(stepData)) {
      switch (stepData.stepNum) {
        case 1:
          this.gradePanelData = {
            purchaseFunctionList: this.purchaseFunctionList
          };
          this.showgradePanel = true;
          break;
        case 2:
          this.showGradeImportExportPanel = true;
          break;
        case 3:
          this.showAssignClaimantToGradePopup = true;
          break;
        case 4:
          this.fnShowAssignCategoriesToGradeListPanel();
          break;

      }
    }
  }
  fnShowAssignCategoriesToGradeListPanel() {
    this.assignCategoriesToGradeListPanelInputModel = new AssignCategoriesToGradeListPanelInputModel(
      this.translate.instant("assign_categories_to_grade")
    );
    this.showAssignCategoriesToGradeListPanel = true;
  }
  fnCloseAssignCategoriesToGradeListPanel() {
    this.showAssignCategoriesToGradeListPanel = false;
    this.assignCategoriesToGradeListPanelInputModel = null;
    this.GetWizardDetails();
  }
  closeAssignClaimanttogradePopup() {
    this.showAssignClaimantToGradePopup = false;
    this.GetWizardDetails();
  }
  fnCloseGradeImportExportPanel() {
    this.showGradeImportExportPanel = false;
    this.GetWizardDetails();
  }
  resetUrl() {
    let myUrl = parse(window.location.href);

    if (!(!myUrl || null) && !(!myUrl.pathname || null)) {
      let urlPath = myUrl.pathname;
      this.location.go(urlPath);
    } else {
      this.location.go("/");
    }
  }
  fnAlertPanelRequired(stepData: Wizard) {
    if (stepData.alertPanelType) {
      switch (stepData.alertPanelType) {
        case AlertPanelTypeEnum.Purchase:
          this.marketingPopupPanel = new MarketingPopup(
            this.translate.instant("assign_categories_to_grade"),
            this.translate.instant("assign_categories_to_grade"),
            this.translate.instant("assign_category_grade_description"),
            null,
            "../../assets/svg-icons/GradesToCatoories.png",
            "../../assets/images/GradesToCatoories.png",
            "",
            FunctionPackageEnum.assigncategoriestograde,
            this.translate.instant("assign_categories_to_grade"),
            "assigncategoriestograde",
            0,
            0
          );
          this.isMarketingPopup = true;
          localStorage.setItem("assigncategoriestogradeRedirection", "grade");
          break;
        case AlertPanelTypeEnum.SetuptIncomplete:
          let text1 = this.translate.instant("urgent_action_msg2") + '<br>' + this.translate.instant("urgent_action_msg3");
          this.alertPanelType = AlertPanelTypeEnum.SetuptIncomplete;
          this.alertPanelModel = new AlertPanelModel(
            true,
            this.translate.instant("label_alert"),
            [text1],
            this.translate.instant("cancel"),
            this.translate.instant("select_mileage"),
            true,
            ""
          );
          break;
        case AlertPanelTypeEnum.NotApplicable:
          this.alertPanelType = AlertPanelTypeEnum.NotApplicable;
          this.alertPanelModel = new AlertPanelModel(
            true,
            this.translate.instant("label_alert"),
            [this.translate.instant("setup_mileage_mgs1")],
            "",
            this.translate.instant("oK_text"),
            true,
            ""
          );
          break;
      }
      return true;
    } else {
      return false;
    }
  }
  alertPanelReceiver(returnValue) {
    if (returnValue) {
      if (this.alertPanelType != AlertPanelTypeEnum.NotApplicable) {
        let stepData = new Wizard();
        stepData.stepNum = 1;
        setTimeout(() => {
          this.navigateToStep(stepData);
        }, 100);
      }
    }
    this.fnClearAlert();
  }
  fnClearAlert() {
    this.alertPanelType = 0;
    this.alertPanelModel = new AlertPanelModel(
      false,
      "",
      [""],
      "",
      "",
      true,
      this.translate.instant("please_review_or_confirm")
    );
  }
  closeMarketingPopup() {
    this.isMarketingPopup = false;
  }
  closeGradePanel()
  {
    this.showgradePanel = false;
    this.GetWizardDetails();
  }
}
